import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-phone-modal',
  templateUrl: 'phone-modal.html',
})
export class PhoneModalPage {
  phone : any = "";
  language = localStorage.getItem('language');
  constructor(public navCtrl: NavController,private viewCtrl : ViewController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
   
  }
  close(){
    this.viewCtrl.dismiss();
  }
  change($event) {
    this.phone = $event.target.value;
  }
  validate(){
    this.viewCtrl.dismiss(this.phone);
  }
}



// WEBPACK FOOTER //
// ./src/pages/signin/phone-modal/phone-modal.ts